import React from "react"
import { useNoteContext } from "./note-context"

export type NoteHeadingProps = {
  children: React.ReactNode
}

export function NoteHeading({ children }: NoteHeadingProps) {
  const { headingId, registerHeading } = useNoteContext()

  React.useLayoutEffect(() => registerHeading(), [registerHeading])

  return (
    <h2 className="font-semibold" data-slot="note-heading" id={headingId}>
      {children}
    </h2>
  )
}
